import {createAction} from "redux-act";

export const fetchPPGameJSONS = createAction('fetchPPGameJSONS');